export default {"src":"/_next/static/media/base.28aabac9.svg","height":96,"width":45,"blurWidth":0,"blurHeight":0};